import { AchievementUnlocked } from "../AchievementUnlocked";

export const Achievement3Content = ({ earnings }) => {
  return <AchievementUnlocked
    earnings={earnings}
    title={'SHOP IS NOW OPEN!'}
    textLines={[
      'PURCHASES HELP PROTECT OVER 4MM ACRES',
      'OF IRL RAINFOREST',
      'USE BONES TO BUY ITEMS',
      'FREE GIFT WITH FIRST PURCHASE'  
    ]}
    arrowSelector={`[data-tutorial-anchor="menu-button-4"]`}
  />
  
};